<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            prop="pmsSkuInfo.skuNo"
            label="商品编号"
            width="180">
    </el-table-column>
    <el-table-column
            prop="startDate"
            label="精选开始日期"
            width="180">
    </el-table-column>
    <el-table-column
            prop="endDate"
            label="精选结束日期"
            width="180">
    </el-table-column>
    <el-table-column
            prop="pmsSkuInfo.merchantsName"
            label="所属农基商"
            width="180">
    </el-table-column>
    <el-table-column
            prop="pmsSkuInfo.skuName"
            label="商品名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="pmsSkuInfo.createTime"
            label="商品创建日期"
            width="180">
    </el-table-column>
    <el-table-column
            prop="pmsSkuInfo.skuInventory"
            label="拥有库存"
            width="180">
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.pmsSkuInfo.id)">查看</el-button>
        <el-button type="text" size="small" @click="del(scope.row.id)">
          <p class="red">删除</p>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "dailyPushTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$emit("view",id)
      },
      del(id){
        this.$emit("del",id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
